import { Component, OnInit, ChangeDetectionStrategy, input } from '@angular/core';

@Component({
  selector: 'app-lost-deal-banner',
  templateUrl: './lost-deal-banner.component.html',
  styleUrls: ['./lost-deal-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: []
})
export class LostDealBannerComponent implements OnInit {
  readonly title = input('');
  constructor() { }

  ngOnInit(): void {
  }

}